/**
 * Hand a Blob to the browser as a download.
 *
 * An object URL and a clicked anchor: the one approach that works in every
 * browser we support, iOS Safari included, without a server to send a
 * `Content-Disposition` header.
 */
export function saveBlob(blob: Blob, fileName: string): void {
  const url = URL.createObjectURL(blob)
  const anchor = document.createElement('a')
  anchor.href = url
  anchor.download = fileName
  anchor.rel = 'noopener'
  document.body.appendChild(anchor)
  anchor.click()
  anchor.remove()
  // Revoke later, not now: Safari cancels a download whose URL vanishes first.
  setTimeout(() => URL.revokeObjectURL(url), 4000)
}

/**
 * A file name built from user text: characters that no file system accepts are
 * dropped, whitespace becomes a dash, letters in any alphabet are kept — a plan
 * called "Toyumuz" or "Свадьба" should be recognisable in a downloads folder.
 */
export function fileSafe(text: string, fallback: string): string {
  const cleaned = text
    .replace(/[\u0000-\u001f<>:"/\\|?*]+/g, '')
    .trim()
    .replace(/\s+/g, '-')
    .replace(/\.+$/, '')
    .slice(0, 60)
  return cleaned || fallback
}
